import React, { useEffect, useRef, useState } from "react";
import * as APPCONFIG from "../config/app-config.js";
import useRazorpay from "react-razorpay";
import MyYuukke from "../api/MyYuukke";

import { toast } from "react-toastify";
import ProfileService from "../api/ProfileService";

const Payment = ({
  email = "notgiven@gmail.com",
  contactNumber = "",
  serviceId = null,
  name = "Other User",
  userId = null,
  amount = 100,
  type = "un_known_premium",
  subscriptionId = null,
  updatePaymentStatus,
  initId = null,
  uId = null,
  auditUUID,
}) => {
  const [Razorpay] = useRazorpay();
  const [orderId, setOrderId] = useState("");

  const redirectUrl = window.location.href; // your dynamic page URL

  const initialized = useRef(false);
  const noResponse = useRef(true);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      handlePayment();
    }
    return () => clearInterval(intervalRef.current);
  }, []);

  //   useEffect(() => {
  //     if (!orderId || !noResponse.current) return;

  //     intervalRef.current = setInterval(() => {
  //       fallbackPaymentCheck();
  //     }, 2500);

  //     return () => clearInterval(intervalRef.current);
  //   }, [orderId]);

  //   const fallbackPaymentCheck = async () => {
  //     try {
  //       if (!orderId) return;
  //       const res = await ProfileService.checkRazorPayFallBack({ orderId });

  //       if (res.data.status === 1) {
  //         const payments = res.data.data.payments || [];

  //         let failed = null;
  //         const captured = payments.find((p) => p.status === "captured");
  //         if (!captured) {
  //           failed = payments.find((p) => p.status === "failed");
  //         }

  //         // SUCCESS
  //         if (captured) {
  //           noResponse.current = false;
  //           clearInterval(intervalRef.current);

  //           savePaymentInfo({
  //             razorpay_payment_id: captured.id,
  //             razorpay_order_id: res.data.data.order_id,
  //             razorpay_signature: `${res.data.data.order_id}|${captured.id}`,
  //             status: "success",
  //             email: captured.email,
  //           });

  //           return;
  //         }

  //         // FAILED
  //         if (failed) {
  //           noResponse.current = false;
  //           clearInterval(intervalRef.current);

  //           updateErrorStatus("error", "PAYMENT-FAILED");

  //           updatePaymentStatus("failed");

  //           return;
  //         }
  //       }
  //     } catch (err) {
  //       console.error("fallbackPaymentCheck error:", err);
  //     }
  //   };

  //   const savePaymentInfo = async (response) => {
  //     console.log("💡 savePaymentInfo called with:", response);
  //     try {
  //       const data = {
  //         paymentId: response.razorpay_payment_id,
  //         orderId: response.razorpay_order_id,
  //         razorpaySignature: response.razorpay_signature || null, // FIXED
  //         amount,
  //         type,
  //         subscriptionId: subscriptionId || null,
  //         email: email || response.email,
  //         serviceId,
  //         name,
  //         realAmount: amount,
  //         razorpayAmount: amount * 100,
  //         status: response.status,
  //       };

  //       if (userId) data.userId = userId;
  //       else if (uId) data.userId = uId;

  //       console.log("✅ FINAL PAYMENT DATA:", data);

  //       const apiCall = userId
  //         ? MyYuukke.savePaymentInforMation(data)
  //         : MyYuukke.savePaymentInforMationWithoutAuth(data);

  //       const res = await apiCall;
  //       console.log("✅ Payment saved:", res);

  //       updatePaymentStatus("success", res.data?.data?.id);
  //       sessionStorage.removeItem("order_id");
  //       clearInterval(intervalRef.current);
  //     } catch (err) {
  //       console.error("❌ savePaymentInfo error:", err);

  //       Swal.fire({
  //         icon: "error",
  //         title: "Payment saved failed!",
  //         text: "If amount is debited, contact support +91 04446314646",
  //       });

  //       updatePaymentStatus("dismiss");
  //       updateErrorStatus("error", "SAVE-FAILED");
  //       clearInterval(intervalRef.current);
  //     }
  //   };

  const origin = window.location.origin;

  // example:
  // http://localhost:3000/booking-success
  // https://yuukke.com/booking-success
  const bookingSuccessUrl = `${origin}/booking-success`;

  const bookingRedirectUrl = `${origin}/my-bookings`;

  const updateErrorStatus = async (status, message) => {
    try {
      const order_id = sessionStorage.getItem("order_id");
      if (!order_id) return;

      await MyYuukke.updateErrorStatus({
        orderId: order_id,
        amount,
        type,
        subscriptionId: subscriptionId || null,
        email,
        status,
        errorStatus: message,
      });

      sessionStorage.removeItem("order_id");
    } catch (err) {
      console.error("updateErrorStatus failed:", err);
    }
  };

  const handlePayment = async () => {
    try {
      const body = {
        emailId: email,
        userId,
        amount: amount * 100,
        realAmount: amount,
        type,
        serviceId,
        ...(initId && { initId }),
        ...(subscriptionId && { subscriptionId }),
        auditUUID: auditUUID,
      };

      const orderResponse = await ProfileService.getOrderInIt(body);
      if (orderResponse.data.message !== "success")
        throw new Error("Order init failed");

      const { id: order_id, currency } = orderResponse.data.data;
      const key = APPCONFIG.razorPayKey;

      sessionStorage.setItem("order_id", order_id);
      setOrderId(order_id);

      const options = {
        key,
        amount: (amount * 100).toString(),
        currency,
        name: "Yuukke Global Venture",
        description: "Transaction in Yuukke",
        image:
          "https://corporate.yuukke.com/bcav2/auth/image/be6f008b-2fb9-4027-9634-642b614c3607",

        order_id,

        // ⚠️ HANDLER → works for card/netbanking
        handler: (response) => {
          if (noResponse.current) {
            noResponse.current = false;
            clearInterval(intervalRef.current);

            updatePaymentStatus("success", 0);

            // ✅ Navigate to success page
            window.location.href = `/success-booking/${response.razorpay_order_id}`;
          }
        },

        prefill: {
          name,
          email,
          contact: contactNumber,
        },

        notes: {
          address: "Yuukke Global Venture",
        },

        theme: {
          color: "#a00030",
        },

        // ✅ REQUIRED FOR UPI (Google Pay / PhonePe)
        redirect: true,

        // ❌ DO NOT USE callback_url
        // callback_url: NOT NEEDED

        modal: {
          ondismiss: () => {
            noResponse.current = false;
            clearInterval(intervalRef.current);

            updateErrorStatus("error", "USER-CLOSED");
            updatePaymentStatus("dismiss");
          },
        },
      };

      const rzp = new Razorpay(options);

      rzp.on("payment.failed", () => {
        updateErrorStatus("error", "PAYMENT-FAILED");
        clearInterval(intervalRef.current);
      });

      rzp.open();
    } catch (err) {
      console.error("handlePayment error:", err);
      toast.error("Something went wrong. Try again!");
      clearInterval(intervalRef.current);
    }
  };

  return <></>;
};

export default Payment;
